import React, { FunctionComponent } from 'react';
import * as Styled from './styled';
import Icon from 'ui/atoms/icon';
import Spacer from 'ui/atoms/spacer';
import { convertFileSize } from 'helper/convert-file-size';

export interface FileToUpload {
  file: File | null;
  documentType?: string;
}

export const FileUploadDocumentContainer: FunctionComponent<{
  uploadedFile: FileToUpload;
  onRemoveDocument: (fileName?: string) => void;
}> = ({ uploadedFile, onRemoveDocument }) => {
  return (
    <Styled.DocumentContainer>
      <Styled.DocumentContent>
        <Icon size="large" name="document" color="primary" />
        <Spacer x={4} />
        <Styled.DocumentTextContainer>
          <Styled.DocumentNameRemove>
            <span>{uploadedFile.file?.name}</span>
            <Spacer x={4} />
            <Icon name="close-thin" onClick={() => onRemoveDocument(uploadedFile?.file?.name)} />
          </Styled.DocumentNameRemove>
          <Spacer y={2} />
          {uploadedFile.file?.size && (
            <Styled.SideTextContent>{convertFileSize(uploadedFile.file?.size)}</Styled.SideTextContent>
          )}
        </Styled.DocumentTextContainer>
      </Styled.DocumentContent>
    </Styled.DocumentContainer>
  );
};

export default FileUploadDocumentContainer;
